module.exports = __webpack_public_path__ + "static/1-04da16dc8ea9621866660628624922cc.jpg";